import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';
import { ORG_HOME_PATH } from '@/shared/layout/nav/rails';
import { Box, CircularProgress } from '@mui/material';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'super_admin') {
    return <Navigate to={ORG_HOME_PATH} replace />;
  }

  if (user.forcePasswordChange) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};

export default SuperAdminRoute;
